import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["linkAs", "title"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
/* eslint-disable jsx-a11y/heading-has-content */
import React from 'react';
import { Button } from 'semantic-ui-react';
var ELEMENT_PROPS = {
  Button: {
    primary: true
  }
};
var ELEMENT_TYPES = {
  span: /*#__PURE__*/React.createElement("span", null),
  p: /*#__PURE__*/React.createElement("p", null),
  // eslint-disable-next-line jsx-a11y/anchor-is-valid, jsx-a11y/anchor-has-content
  a: /*#__PURE__*/React.createElement("a", null),
  Button: /*#__PURE__*/React.createElement(Button, null),
  h1: /*#__PURE__*/React.createElement("h1", null),
  h2: /*#__PURE__*/React.createElement("h2", null),
  h3: /*#__PURE__*/React.createElement("h3", null),
  h4: /*#__PURE__*/React.createElement("h4", null)
};
function getElementProps(linkAs) {
  return ELEMENT_PROPS[linkAs] || {};
}
function getLinkElement(linkAs) {
  return ELEMENT_TYPES[linkAs] || ELEMENT_TYPES.span;
}
export default function LinkContent(_ref) {
  var linkAs = _ref.linkAs,
    title = _ref.title,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.cloneElement(getLinkElement(linkAs), _objectSpread(_objectSpread({
    children: title
  }, getElementProps(linkAs)), rest));
}